const getOneOrZero = () => {
  const rand = Math.random() * 2;
  return Math.floor(rand);
};

export default getOneOrZero;